import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { SmlAsset } from "@src/types/intelligence-search";

export function formatNumber(n: number, options?: any) {
    return Intl.NumberFormat("en-US", options).format(n);
}

/**
 * Convert schema field type to readable string format
 */
export function convertFieldTypeToString(fieldType: string): string {
    switch (fieldType) {
        case "STRING":
            return "string";
        case "BYTES":
            return "bytes";
        case "INTEGER":
        case "INT64":
            return "int";
        case "FLOAT":
        case "FLOAT64":
            return "float";
        case "BOOLEAN":
        case "BOOL":
            return "bool";
        case "TIMESTAMP":
            return "timestamp";
        case "DATE":
            return "date";
        case "TIME":
            return "time";
        case "DATETIME":
            return "datetime";
        case "GEOGRAPHY":
            return "geography";
        case "NUMERIC":
            return "numeric";
        case "BIGNUMERIC":
            return "bignumeric";
        case "JSON":
            return "json";
        case "RECORD":
        case "STRUCT":
            return "record";
        case "RANGE":
            return "range";
        default:
            return fieldType.toLowerCase();
    }
}

export function getRenderer(schema?: { field_type: string; name: string; mode: string }, assetMetadata?: any) {
    if (schema === undefined) {
        return (v: any) => v;
    }

    switch (convertFieldTypeToString(schema.field_type)) {
        case "string": {
            return (v: string) => <span>{v}</span>;
        }

        case "int":
        case "float": {
            const numberFormatConf = assetMetadata ? assetMetadata["format"] : {};
            return (v: number) => formatNumber(v, numberFormatConf);
        }

        case "bool": {
            return (v: boolean) => {
                return v ? <CheckOutlined className="text-green-600" /> : <CloseOutlined className="text-red-600" />;
            };
        }
        case "date": {
            return (v: string) => <span>{v}</span>;
        }
        default: {
            return (v: any) => <span>{String(v)}</span>;
        }
    }
}

export function createRendererMapping(
    schemas?: { field_type: string; name: string; mode: string }[],
    refAssets?: SmlAsset[],
) {
    return (schemas || [])
        .map((schema) => {
            const assetMetadata = refAssets?.find((asset) => asset.name === schema.name)?.metadata;
            return {
                [schema.name]: getRenderer(schema, assetMetadata),
            };
        })
        .reduce((a, b) => Object.assign(a, b), {});
}
